import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Strikethrough = createReactComponent("Strikethrough", ["svg", defaultAttributes, [["path", {
  d: "M16 4H9a3 3 0 00-2.83 4",
  key: "1xkz4h"
}], ["path", {
  d: "M14 12a4 4 0 010 8H6",
  key: "1f88cb"
}], ["line", {
  x1: "4",
  y1: "12",
  x2: "20",
  y2: "12",
  key: "e1pn9i"
}]]]);
export default Strikethrough;